var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.572 1.98515C9.88083 1.58848 8.12077 1.58848 6.42957 1.98515C4.22429 2.50239 2.50244 4.2241 1.98517 6.42907C1.58848 8.12008 1.58848 9.87993 1.98517 11.5709C2.50244 13.7759 4.22429 15.4976 6.42957 16.0149C8.12077 16.4115 9.88083 16.4115 11.572 16.0149C13.7773 15.4976 15.4992 13.7759 16.0164 11.5709C16.4131 9.87992 16.4131 8.12008 16.0164 6.42908C15.4992 4.22411 13.7773 2.50239 11.572 1.98515ZM17.6595 6.04364C18.1156 7.98815 18.1156 10.0118 17.6595 11.9564C16.9958 14.7854 14.7867 16.9943 11.9574 17.6579C10.0127 18.114 7.98888 18.114 6.0442 17.6579C3.21496 16.9943 1.0058 14.7854 0.342127 11.9564C-0.114042 10.0118 -0.114042 7.98815 0.342127 6.04363C1.0058 3.21457 3.21496 1.00567 6.0442 0.342086C7.98888 -0.114028 10.0127 -0.114029 11.9574 0.342086C14.7867 1.00567 16.9958 3.21457 17.6595 6.04364ZM10.7168 5.66947C10.8977 5.23996 10.6961 4.74517 10.2666 4.56433C9.83705 4.38348 9.34226 4.58507 9.16142 5.01459L6.91121 10.359C6.80152 10.6195 6.82957 10.9177 6.98594 11.1532C7.14231 11.3887 7.40623 11.5303 7.68892 11.5303H11.6268C12.0928 11.5303 12.4706 11.1525 12.4706 10.6864C12.4706 10.2204 12.0928 9.84261 11.6268 9.84261H8.95977L10.7168 5.66947Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 15.0021,
    y1: 1.40418,
    x2: 5.43872,
    y2: 17.7181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.232292,
    stopColor: "#DD2736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711458,
    stopColor: "#6FD3D1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.c2b93fdafe7927e5d2b2da181752a3bf.svg";
export { ForwardRef as ReactComponent };